import { useLang } from "@/lib/lang";

export const Marquee = () => {
  const { t } = useLang();
  const row = t.marquee.map((m, i) => (
    <span key={i} className="flex items-center gap-10 pr-10">
      <span className={i % 2 ? "font-serif italic text-gold" : "font-display text-ink"}>{m}</span>
      <span className="h-2 w-2 rotate-45 bg-zinc-500" />
    </span>
  ));
  return (
    <div className="relative overflow-hidden border-y border-line bg-surface py-7" data-testid="marquee">
      <div className="marquee flex w-max text-3xl tracking-tight sm:text-5xl">
        <div className="flex">{row}</div>
        <div className="flex" aria-hidden="true">{row}</div>
      </div>
    </div>
  );
};
